import axios from "axios";
import { parseCookies, setCookie } from "nookies";

export const api = axios.create({
  baseURL: import.meta.env.VITE_BACKOFFICE_API,
  headers: {
    "auth-token": parseCookies()["backoffice_token"],
    Authorization: `Bearer ${parseCookies()["backoffice_token"]}`,
  },
});

api.interceptors.response.use((response) => {
  if (response.data.auth_token) {
    api.defaults.headers["auth-token"] = response.data.auth_token;
    setCookie(null, "backoffice_token", response.data.auth_token, {
      path: "/",
      domain: "woba.com.br",
    });
  }

  return response;
});
